import { emptyDatiqGeoSuggestion } from '@dat/datiq-core/models';
import { IDatiqCellLane } from './datiq-cell-lane.interface';

export const emptyDatiqCellLane: IDatiqCellLane = {
    origin: { ...emptyDatiqGeoSuggestion },
    destination: { ...emptyDatiqGeoSuggestion },
};
